import ApiManager from './ApiManager';
import AxiosApi from '../api';
import { Database } from './DexieDB/class/Database';

const db = new Database();

const api = new ApiManager(AxiosApi, db);

export { api, db };

export default api;
